import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";
import { ICrmUserData } from "common/records/CrmUser";

export const FETCH_CRM_USER = "@crmUser/FETCH_CRM_USER";
export const RECEIVE_CRM_USERS = "@crmUser/RECEIVE_CRM_USERS";
export const RECEIVE_CRM_USER = "@crmUser/RECEIVE_CRM_USER";
export const RESET_CRM_USER = "@crmUser/RESET_CRM_USER";

export const CrmUserActions = {
  // SINGLE
  fetchCrmUser: (id: number) => createAction(FETCH_CRM_USER, { id }),
  receiveCrmUser: (user: ICrmUserData) => createAction(RECEIVE_CRM_USER, user),
  resetCrmUser: (userId: number) => createAction(RESET_CRM_USER, userId),
  // MULTIPLE
  receiveCrmUsers: (users: ICrmUserData[]) => createAction(RECEIVE_CRM_USERS, users),
};
export type CrmUserActions = ActionsUnion<typeof CrmUserActions>;
